import { combineReducers } from 'redux'
import response_register_email from './AuthUser/AuthUserReducers'


const rootReducer = combineReducers({    
    response_register_email
})

export default rootReducer